import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';
import { UserI } from '../interfaces/users/user.interface';
@Injectable({
  providedIn: 'root'
})

/*
* Servicio para manejar las alertas de eventos y retroalimentación al usuario, utiliza Sweet Alert
* */
export class MessageService {

  // region Atributos
  message: any;
  status: string;
  deletePopOup: any;
  // endregion

  // region Métodos

  // Función para imprimir los mensajes de retroalimentación del backend o errores de aplicación, incluye una bandera por si es mensaje de status de envio de un correo
  printStatus(message: any, status: string, mailed?: boolean) {
    this.message = message;
    this.status = status;

    if (this.status === 'success') {
      Swal.fire({
        html: '' + this.message,
        icon: this.status,
        showConfirmButton: false,
        timer: mailed ? 4000 : 2500,
        heightAuto: false
      });

    } else if (this.status === 'error') {
      Swal.fire({
        html: '' + this.message,
        icon: this.status,
        timer: 5000,
        heightAuto: false
      });
    } else if (this.status === 'warning') {
      Swal.fire({
        html: '' + this.message,
        icon: this.status,
        timer: 4000,
        heightAuto: false
      });
    }
  }


  printStatusArray(message: [], status: string, mailed?: boolean) {
    let msg;
    for (let i = 0; i < message.length; i ++) {
      msg = message[i] + '<br>';
    }
    this.status = status;

    if (this.status === 'success') {
      Swal.fire({
        html: '' + msg,
        icon: this.status,
        showConfirmButton: false,
        timer: mailed ? 4000 : 2500,
        heightAuto: false
      });

    } else if (this.status === 'error') {
      Swal.fire({
        html: '' + msg,
        icon: this.status,
        timer: 5000,
        heightAuto: false
      });
    } else if (this.status === 'warning') {
      Swal.fire({
        html: '' + msg,
        icon: this.status,
        timer: 4000,
        heightAuto: false
      });
    }
  }

  // Función para preguntar al usuario si desea continuar, con mensaje configurable
  confirmRequest(msg?, confirmBtnText?, cancelBtnText?, feed?) {
    this.deletePopOup = Swal.fire({
      title: msg ? msg : 'Are you sure to proceed ?',
      text: feed ? feed : '',
      icon: 'warning',
      showCancelButton: true,
      focusCancel: true,
      confirmButtonText: confirmBtnText ? confirmBtnText : 'Yes',
      cancelButtonText: cancelBtnText ? cancelBtnText : 'Discard',
      confirmButtonColor: '#1d7a18',
      heightAuto: false
    });
    return this.deletePopOup;
  }

  // Función para preguntar al usuario se desea continuar con la eliminación de un elemento
  confirmRemove() {
    this.deletePopOup = Swal.fire( {
      title: 'Are you sure you want to remove this item ?',
      text: 'This action cannot be undone',
      icon: 'warning',
      showCancelButton: true,
      focusCancel: true,
      confirmButtonText: 'Remove',
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#ce3600',
      heightAuto: false
    });
    return this.deletePopOup;
  }

  // Función para notificar que fue cancelada la acción
  dismissRemove() {
    this.deletePopOup = Swal.fire({
      title: 'Canceled',
      text: 'Your information is safe :), action canceled',
      icon: 'info',
      timer: 1000,
      heightAuto: false
    });
    return this.deletePopOup;
  }


  dismissAction() {
    this.deletePopOup = Swal.fire({
      title: 'Canceled',
      text: 'Action canceled',
      icon: 'info',
      timer: 1000,
      heightAuto: false
    });
    return this.deletePopOup;
  }

  // Función para preguntar al usuario si desea continuar con la eliminación de un elemento
  confirmDelete() {
    this.deletePopOup = Swal.fire({
      title: 'Are you sure you want to delete the item ?',
      text: 'This action cannot be undone',
      icon: 'warning',
      showCancelButton: true,
      focusCancel: true,
      confirmButtonText: 'Delete',
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#b20909',
      heightAuto: false
    });
    return this.deletePopOup;
  }

  // Función para mostrar mensaje de cancelación de acción
  dismissDelete() {
    this.deletePopOup = Swal.fire({
      title: 'Action Cancel',
      text: 'No changes applied',
      icon: 'info',
      timer: 1500,
      heightAuto: false
    });
    return this.deletePopOup;
  }

  // async confirmNotification(user?: UserI) {
  //   let title = (user) ? `Ingresa la notificación para el usuario: ${user.name}` : 'Ingresa la notificación a enviar';
  //   return await Swal.fire({
  //      title,
  //      input: 'text',
  //      inputValue: '',
  //      showCancelButton: true,
  //      cancelButtonText: 'Cancelar',
  //      heightAuto: false,
  //      inputValidator: (value) => {
  //        if (!value) {
  //          return 'Debes indicar el mensaje de la notificación'
  //        }
  //      }
  //    });
  //  }

   async confirmNotification(user?: UserI) {
    let title = (user) ? `Ingresa la notificación para el usuario: ${user.name}` : 'Ingresa la notificación a enviar';
    return await Swal.fire({
       title,
       html: `
       <label style="text-align: left;width: 100%;margin-top: 12px;">Tipo Notificación</label>
       <select name="type" id="type" class="swal2-input">
          <option value="1">Personal</option>
          <option value="2">General</option>
          <option value="3">Importante</option>
       </select>
       <label style="text-align: left;width: 100%;margin-top: 12px;">Mensaje</label>
       <input type="text" id="message" name="message" class="swal2-input">
       `,
       showCancelButton: true,
       cancelButtonText: 'Cancelar',
       heightAuto: false,
       preConfirm: () => [
        //@ts-ignore
       {type: document.querySelector('#type').value ? Number(document.querySelector('#type').value) :  Swal.showValidationMessage(`Selecciona una opción valida`)},
       //@ts-ignore
       {message: document.querySelector('#message').value ? document.querySelector('#message').value : Swal.showValidationMessage(`Debes indicar el mensaje de la notificación`)},
     ],
     });
   }



  // endregion
  constructor() { }
}
